const borough_labels = {
  "type":"FeatureCollection",
  "features": [
    {
      "type":"Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
          -73.96650782568467,
          40.783233713850535
        ]
      },
      "properties": {
        "name": "Manhattan"
      }
    },
    {
      "type":"Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
          -73.8733309306482,
          40.851231985684734
        ]
      },
      "properties": {
        "name": "Bronx"
      }
    },
    {
      "type":"Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
          -73.81209808316632,
          40.72849600779969
        ]
      },
      "properties": {
        "name": "Queens"
      }
    },
    {
      "type":"Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
          -73.95577540845343,
          40.65435912989912
        ]
      },
      "properties": {
        "name": "Brooklyn"
      }
    },
    {
      "type":"Feature",
      "geometry": {
        "type": "Point",
        "coordinates": [
          -74.15199701416635,
          40.58366082400295
        ]
      },
      "properties": {
        "name": "Staten Island"
      }
    }
  ]
}
export default borough_labels;


/** WEBPACK FOOTER **
 ** ./src/static/data/borough_labels.js
 **/